export default __webpack_public_path__ + "static/media/smile_end.166d1e2f.jpg";